import { render } from "./checkContentDefault.vue?vue&type=template&id=0dd61816&scoped=true&ts=true"
import script from "./checkContentDefault.vue?vue&type=script&lang=ts"
export * from "./checkContentDefault.vue?vue&type=script&lang=ts"

import "./checkContentDefault.vue?vue&type=style&index=0&id=0dd61816&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd61816"]])

export default __exports__